(function ($) {
	$(function () {
		$('.newsSingleGallery a').fancybox();
	});
})(jQuery);